const initialState = {
	list: [],
};

export default function reducer(state = initialState, action) {
	if (action.type === 'SEARCH_CONDITION_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		return newState;
	}
	else {
		return state;
	}
}
